export default "__VITE_ASSET__BmoPdLM8__"